import React from "react";
import { Route } from "react-router-dom";
import {
  isAuthenticated,
  getUserRole,
  setOriginalUrl,
} from "../../utils/utils";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const ProtectedRoute = ({
  component: Component,
  redirectPathname: targetPath,
  accessLevel,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated()) {
          setOriginalUrl((props.location?.pathname).split("/")[1]);
          if (accessLevel.includes(getUserRole())) {
            return <Component {...props} />;
          } else {
            return <Redirect to="/" />;
          }
        } else {
          setOriginalUrl(props.location?.pathname);
          return (
            <Redirect
              to={{
                pathname: targetPath,
                state: { from: props.location },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
